import React, { useEffect } from 'react';
import Phaser from 'phaser';

const Game: React.FC = () => {
    useEffect(() => {
        const config: Phaser.Types.Core.GameConfig = {
            type: Phaser.WEBGL, // Explicitly using WebGL
            parent: 'game-container',
            width: window.innerWidth,
            height: window.innerHeight,
            scale: {
                mode: Phaser.Scale.RESIZE, // Automatically resize
                autoCenter: Phaser.Scale.CENTER_BOTH // Center the game canvas in the middle of the screen
            },
            scene: {
                preload() {
                    // Preload assets here if necessary
                },
                create() {
                    const centerX = this.cameras.main.centerX;
                    const centerY = this.cameras.main.centerY;
                    this.add.text(centerX, centerY, 'Hello Phaser!', {
                        font: '32px Arial',
                        color: '#0f0'
                    }).setOrigin(0.5, 0.5); // Ensuring text is centered
                },
                update() {
                    // Update loop if necessary for the game
                }
            }
        };

        const game = new Phaser.Game(config);

        return () => {
            game.destroy(true); // Cleanup the game when the component is unmounted
        };
    }, []);

    return <div id="game-container" style={{ width: '100vw', height: '100vh' }} />;
};

export default Game;